import React, { Component } from 'react'
import { SideNavItem, SideNav } from 'react-materialize'
import { withRouter } from 'react-router-dom'

class Sidebar extends Component {
  render() {
    const { chat1, chat2 } = this.props.chatState
    return (
      <SideNav
        trigger={
          <div className="burgerContainer">
            <div className="hamburger">
              <div className="line1" />
              <div className="line2" />
              <div className="line3" />
              <div className="line4" />
            </div>
          </div>
        }
        options={{ closeOnClick: true, edge: 'right' }}
      >
        <SideNavItem
          href="#!icon"
          icon="close"
          style={{ marginBottom: '-7px' }}
        >
          React ChatBot
        </SideNavItem>
        <SideNavItem divider />
        <SideNavItem subheader>
          <div>Options</div>
        </SideNavItem>
        <SideNavItem divider />
        <SideNavItem waves onClick={this.props.openChat2}>
          {chat2 ? 'Close ReactBot' : 'Enable ReactBot'}
        </SideNavItem>
        {this.props.hasPermission && (
          <SideNavItem waves onClick={this.props.openChat1}>
            {chat1 ? 'Close Custom Chat' : 'Enable Custom Chat'}
          </SideNavItem>
        )}
        <SideNavItem waves onClick={this.props.enableFloating}>
          {this.props.enableFloatingState
            ? 'Disable Floating'
            : 'Enable Floating'}
        </SideNavItem>

        <SideNavItem waves onClick={() => this.props.history.push('/login')}>
          Login
        </SideNavItem>
      </SideNav>
    )
  }
}

export default withRouter(Sidebar)
